import styled, { css } from 'styled-components';
import FadeInUp from '../../../atoms/fade-in-up';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    grid-column: 1 / -1;
    margin-bottom: 6.4rem;
    margin-top: 6.4rem;
    margin-bottom: 6.4rem;
    ${theme.screenSize.s576.mediaQuery} {
      margin-bottom: 7.2rem;
      grid-column: 2 / 12;
    }
    ${theme.screenSize.s768.mediaQuery} {
      margin-bottom: 12.4rem;
      margin-top: 11.2rem;
    }
  `}
`;

export const Message = styled(FadeInUp)`
  ${({ theme }) => css`
    ${theme.fonts.sohne.light}
    color: ${theme.colors.white};
    font-size: 2.4rem;
    line-height: 1.4;
    margin-bottom: 6.4rem;
    text-align: center;
    ${theme.screenSize.s576.mediaQuery} {
      font-size: 3.2rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      font-size: 3.6rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      font-size: 3.6rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 4.8rem;
      line-height: 1.3;
    }
  `}
`;

export const CTAWrapper = styled(FadeInUp)`
  text-align: center;
`;
